import { render, staticRenderFns } from "./stadistics.vue?vue&type=template&id=6edb4620&scoped=true&"
import script from "./stadistics.vue?vue&type=script&lang=js&"
export * from "./stadistics.vue?vue&type=script&lang=js&"
import style0 from "./stadistics.vue?vue&type=style&index=0&id=6edb4620&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edb4620",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VDatePicker,VProgressCircular})
